import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './polyfills';
import './index.scss';
import '../styles/index.scss';
import App from './app';
import configureStore from './store/store';
import ErrorBoundary from './error-boundary';

const store = configureStore();

const Application = () => {
    return (
        <ErrorBoundary>
            <Provider store={store}>
                <App />
            </Provider>
        </ErrorBoundary>
    );
};

ReactDOM.render(<Application />, document.getElementById('ccpa-root'));
